module.exports = __webpack_public_path__ + "static/media/product (5).75d85b2e.jpg";